// components/EventSummary/EnrollmentStatus.js

import React from 'react';
import styled from 'styled-components';
import Typography from '../Typography';
import { theme } from '../../theme';
import ArrowRightIcon from '../Icons/ArrowRightIcon';
// import { TICKET_FREE } from '../../constants/eventTypes';
import { useAttendeeStateTranslations } from '../../constants/attendeeStates';
import { ATTENDEE_STATES } from '../../constants/attendeeStates';
import { useTranslation } from 'react-i18next';

const EnrollmentStatus = ({ enrollmentStatus, ticketType, approvalRequired, cancellationDenied, userMessage, onViewDetails }) => {
  const { getStateLabel, getStateMessage } = useAttendeeStateTranslations();
  const { t } = useTranslation('eventDetail');

  // console.log('EnrollmentStatus en EnrollmentStatus:', enrollmentStatus);

  // Función auxiliar para renderizar mensajes
  const renderStateMessage = (state) => {
    const message = getStateMessage(state);

    // Si el mensaje es un objeto con title y description, solo mostrar la description
    if (typeof message === 'object' && message.title && message.description) {
      return (
        <Typography $variant="body-2-regular" $variantTablet="body-2-regular" $variantMobile="body-2-regular" color={theme.colors.inverseStrong}>
          {message.description}
        </Typography>
      );
    }

    // Si es un string simple
    return (
      <Typography $variant="body-2-regular" $variantTablet="body-2-regular" $variantMobile="body-2-regular" color={theme.colors.inverseStrong}>
        {message}
      </Typography>
    );
  };

  return (
    <StatusBlock>
      {/* Tickets gratis - Inscripcion pendiente de aceptación */}
      {enrollmentStatus === ATTENDEE_STATES.CONFIRMATION_PENDING && (
        <>
          <StatusInfo onClick={onViewDetails}>
            <StatusInfoInner>
              <StatusVisual>
                <StatusIcon src="/icons/ticket-approval-required-solid.svg" alt="ticket-approval-required icon" />
              </StatusVisual>
              <StatusContent>
                <Typography $variant="body-1-semibold" $variantTablet="body-1-semibold" $variantMobile="body-1-semibold" color={theme.colors.inverseMain}>
                  {getStateLabel(enrollmentStatus)}
                </Typography>
                {renderStateMessage(enrollmentStatus)}
              </StatusContent>
            </StatusInfoInner>
            <DrawerLink>
              <Typography as="p" $variant="body-2-semibold" color={theme.colors.inverseStrong}>
                {t('eventDetailHeader.viewEnrollment')}
              </Typography>
              <ArrowRightIcon height={20} width={20} fill={theme.colors.inverseStrong} />
            </DrawerLink>
          </StatusInfo>
        </>
      )}
      {/* Tickets de pago - Solicitud de cancelación */}
      {enrollmentStatus === ATTENDEE_STATES.CANCELLATION_PENDING && (
        <>
          <StatusInfo onClick={onViewDetails}>
            <StatusInfoInner>
              <StatusVisual>
                <StatusIcon src="/icons/ticket-approval-required-solid.svg" alt="cancellation-pending icon" />
              </StatusVisual>
              <StatusContent>
                <Typography $variant="body-1-semibold" $variantTablet="body-1-semibold" $variantMobile="body-1-semibold" color={theme.colors.inverseMain}>
                  {getStateLabel(enrollmentStatus)}
                </Typography>
                {renderStateMessage(enrollmentStatus)}
              </StatusContent>
            </StatusInfoInner>
            <DrawerLink>
              <Typography as="p" $variant="body-2-semibold" color={theme.colors.inverseStrong}>
                {t('eventDetailHeader.viewEnrollment')}
              </Typography>
              <ArrowRightIcon height={20} width={20} fill={theme.colors.inverseStrong} />
            </DrawerLink>
          </StatusInfo>
          {userMessage && (
            <div style={{ display: 'flex', flexDirection: 'column', width: '100%', gap: '4px', padding: '16px', backgroundColor: '#f5f5f5', alignItems: 'flex-start' }}>
              <Typography $variant="body-2-semibold" color={theme.colors.warningMain}>
                {t('eventDetailHeader.requestMessage')}
              </Typography>
              <Typography $variant="body-2-regular" color={theme.colors.inverseStrong}>
                {userMessage}
              </Typography>
            </div>
          )}
        </>
      )}
      {/* Tickets de pago & gratis - Asistencia confirmada */}
      {enrollmentStatus === ATTENDEE_STATES.ATTENDING && (
        <>
          <StatusInfo onClick={onViewDetails}>
            <StatusInfoInner>
              <StatusVisual>
                <StatusIcon src="/icons/ticket-check-solid-negative.svg" alt="ticket-check icon" />
              </StatusVisual>
              <StatusContent>
                <Typography $variant="body-1-semibold" $variantTablet="body-1-semibold" $variantMobile="body-1-semibold" color={theme.colors.inverseMain}>
                  {getStateLabel(enrollmentStatus)}
                </Typography>
                {cancellationDenied && (
                  <Typography $variant="body-2-regular" $variantTablet="body-2-regular" $variantMobile="body-2-regular" color={theme.colors.inverseStrong}>
                    {t('eventDetailHeader.cancellationDenied')}
                  </Typography>
                )}
              </StatusContent>
            </StatusInfoInner>
            <DrawerLink>
              <Typography as="p" $variant="body-2-semibold" color={theme.colors.inverseStrong}>
                {t('eventDetailHeader.viewEnrollment')}
              </Typography>
              <ArrowRightIcon height={20} width={20} fill={theme.colors.inverseStrong} />
            </DrawerLink>
          </StatusInfo>
        </>
      )}
      {/* Tickets de pago - Reembolso aceptado */}
      {enrollmentStatus === ATTENDEE_STATES.REFUND_ACCEPTED && (
        <>
          <StatusInfo onClick={onViewDetails}>
            <StatusInfoInner>
              <StatusVisual>
                <StatusIcon src="/icons/ticket-check-solid-negative.svg" alt="refund-accepted icon" />
              </StatusVisual>
              <StatusContent>
                <Typography $variant="body-1-semibold" $variantTablet="body-1-semibold" $variantMobile="body-1-semibold" color={theme.colors.inverseMain}>
                  {getStateLabel(enrollmentStatus)}
                </Typography>
                {renderStateMessage(enrollmentStatus)}
              </StatusContent>
            </StatusInfoInner>
            <DrawerLink>
              <Typography as="p" $variant="body-2-semibold" color={theme.colors.inverseStrong}>
                {t('eventDetailHeader.viewEnrollment')}
              </Typography>
              <ArrowRightIcon height={20} width={20} fill={theme.colors.inverseStrong} />
            </DrawerLink>
          </StatusInfo>

        </>
      )}
      {/* Tickets de pago - Reembolso procesado */}
      {enrollmentStatus === ATTENDEE_STATES.REFUNDED && (
        <>
          <StatusInfo onClick={onViewDetails}>
            <StatusInfoInner>
              <StatusVisual>
                <StatusIcon src="/icons/ticket-check-solid-negative.svg" alt="refunded icon" />
              </StatusVisual>
              <StatusContent>
                <Typography $variant="body-1-semibold" $variantTablet="body-1-semibold" $variantMobile="body-1-semibold" color={theme.colors.inverseMain}>
                  {getStateLabel(enrollmentStatus)}
                </Typography>
                {renderStateMessage(enrollmentStatus)}
              </StatusContent>
            </StatusInfoInner>
            <DrawerLink>
              <Typography as="p" $variant="body-2-semibold" color={theme.colors.inverseStrong}>
                {t('eventDetailHeader.viewEnrollment')}
              </Typography>
              <ArrowRightIcon height={20} width={20} fill={theme.colors.inverseStrong} />
            </DrawerLink>
          </StatusInfo>

        </>
      )}
      {/* Tickets de pago & gratis - Asistencia cancelada */}
      {(enrollmentStatus === ATTENDEE_STATES.NOT_ATTENDING ||
        enrollmentStatus === ATTENDEE_STATES.CANCELLED_BY_USER ||
        enrollmentStatus === ATTENDEE_STATES.CANCELLED_BY_ORGANIZER ||
        enrollmentStatus === ATTENDEE_STATES.REJECTED_BY_ORGANIZER) && (
          <>
            <StatusInfo onClick={(enrollmentStatus === ATTENDEE_STATES.CANCELLED_BY_ORGANIZER ||
              enrollmentStatus === ATTENDEE_STATES.REJECTED_BY_ORGANIZER ||
              enrollmentStatus === ATTENDEE_STATES.CANCELLED_BY_USER) ? onViewDetails : undefined}>
              {(enrollmentStatus === ATTENDEE_STATES.CANCELLED_BY_ORGANIZER ||
                enrollmentStatus === ATTENDEE_STATES.REJECTED_BY_ORGANIZER) ? (
                <StatusInfoInner>
                  <StatusVisual>
                    <StatusIcon src="/icons/ticket-cancel-solid.svg" alt="ticket-cancel icon" />
                  </StatusVisual>
                  <StatusContent>
                    <Typography $variant="body-1-semibold" $variantTablet="body-1-semibold" $variantMobile="body-1-semibold" color={theme.colors.inverseMain}>
                      {getStateLabel(enrollmentStatus)}
                    </Typography>
                    {renderStateMessage(enrollmentStatus)}
                  </StatusContent>
                </StatusInfoInner>
              ) : (
                <StatusInfoInner>
                  <StatusVisual>
                    <StatusIcon src="/icons/ticket-cancel-solid.svg" alt="ticket-cancel icon" />
                  </StatusVisual>
                  <StatusContent>
                    <Typography $variant="body-1-semibold" $variantTablet="body-1-semibold" $variantMobile="body-1-semibold" color={theme.colors.inverseMain}>
                      {getStateLabel(enrollmentStatus)}
                    </Typography>
                    {renderStateMessage(enrollmentStatus)}
                  </StatusContent>
                </StatusInfoInner>
              )}
              {(enrollmentStatus === ATTENDEE_STATES.CANCELLED_BY_ORGANIZER ||
                enrollmentStatus === ATTENDEE_STATES.REJECTED_BY_ORGANIZER ||
                enrollmentStatus === ATTENDEE_STATES.CANCELLED_BY_USER) && (
                  <DrawerLink>
                    <Typography as="p" $variant="body-2-semibold" color={theme.colors.inverseStrong}>
                      {t('eventDetailHeader.viewEnrollment')}
                    </Typography>
                    <ArrowRightIcon height={20} width={20} fill={theme.colors.inverseStrong} />
                  </DrawerLink>
                )}
            </StatusInfo>

          </>
        )}
    </StatusBlock>
  );
};

export default EnrollmentStatus;

const StatusBlock = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  overflow: hidden;
  border-radius: ${({ theme }) => theme.radius.sm};
  transition: transform 0.2s ease;

  &:hover {
    transform: translateY(-2px);
  }
  
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    border-radius: 0px;

    &:hover {
      transform: translateY(0px);
    }
  }
`;

const StatusVisual = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  background-color: ${({ theme }) => theme.fill.inverseWeak};
  border-radius: ${({ theme }) => theme.radius.xs};
`;

const StatusIcon = styled.img`
  width: 24px;
  height: 24px;
`;

const StatusInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  padding: ${({ theme }) => theme.sizing.sm};
  width: 100%;
  background-color: ${({ theme }) => theme.fill.inverseMain};
  cursor: ${props => props.onClick ? 'pointer' : 'default'};
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${({ theme }) => theme.fill.inverseWeak};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: ${({ theme }) => theme.sizing.xs} ${({ theme }) => theme.sizing.sm};
  }
`;

const StatusInfoInner = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: ${({ theme }) => theme.sizing.sm};
  flex-grow: 1;
  // width: 100%;
`;

const StatusContent = styled.div`
  display: flex;
  flex-direction: column;
  // gap: 4px;
`;

const DrawerLink = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    p {
      display: none;
    }
  }
`;

const ViewDetailsButton = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${({ theme }) => theme.colors.inverseStrong};
`;

const ViewDetailsText = styled.span`
  font-size: 14px;
  font-weight: 500;
  
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: none;
  }
`;
